import { Layers, Sources } from "@/store/map/types";

const airShadow = "rgba(255, 255, 255, 0.8)";

var roadsLayout = {
    "line-cap": "round",
    "line-join": "round",
};

export var airShadowsStyle = (source: Sources) => {
    return {
        id: Layers.AirBackground,
        type: "line",
        source: source,
        "source-layer": "air",
        layout: roadsLayout,
        paint: {
            "line-width": {
                stops: [
                    [8, 2.5],
                    [16, 14],
                ],
            },
            "line-color": airShadow,
        },
    };
};

export var airStyle = (source: Sources) => {
    return {
        id: Layers.Air,
        type: "line",
        source: source,
        "source-layer": "air",
        layout: roadsLayout,
        paint: {
            "line-width": {
                stops: [
                    [7, 3],
                    [14, 14],
                    [18, 20],
                ],
            },
        },
    };
};

export var airInternationalStyle = (source: Sources) => {
    return {
        id: Layers.AirInternational,
        type: "line",
        source: source,
        "source-layer": "air",
        layout: roadsLayout,
        paint: {
            "line-width": {
                stops: [
                    [7, 3],
                    [14, 14],
                    [18, 20],
                ],
            },
        },
    };
};

export var regionIconsStyle = {
    type: "symbol",
    layout: {
        "icon-image": ["get", "icon"],
        "icon-size": [
            "interpolate",
            ["exponential", 1.2],
            ["zoom"],
            2,
            0.05,
            8,
            0.4,
        ],
        "icon-allow-overlap": true,
        "icon-ignore-placement": true,
        "icon-anchor": "center",
        "text-field": ["get", "name"],
        "text-offset": [0, 1.2],
        "text-anchor": "top",
        "text-optional": true,
    },
    paint: {
        "text-color": "#333",
        "text-halo-color": "#fff",
        "text-halo-width": 1,
    },
};
